const GetAllLeadPartyRequest = function () {
  return {
    "leadPartyDTO": {
      tckn: null,
      name: null,
      surname: null,
      phone: null,
      email: null,
      investmentConsultant: null,
      channel: null,
      hasNFCPhone: null,
      primaryContactType: null,
      partyStatus: null,
      fullName: null,
      isWaitingCall: null,
      motherName: null,
      fatherName: null,
      birthPlace: null,
      gender: null,
      birthDate: null,
      phoneVerified: null,
      emailVerified: null,
      identitySerialNo: null,
      identityValidityDate: null,
      identityIssueOffice: null,
      meetingChoice: null,
      status: null,
      domainId: null
    },
    processDefinitionCodes: null,
    partyStatues: null,
    businessStatues: null,
    leadIds: null,
    leadPartyApplicationName: null,
    pageSize: 100,
    page: 0,
    sorts: [
      {
        fieldName: 'modifyStamp.dateTime',
        sortOrder: 'desc'
      }
    ]
  }
};

export default GetAllLeadPartyRequest;



// WEBPACK FOOTER //
// ./src/service/request/GetAllLeadPartyRequest.js